// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MNk3","colBig":"styles_colBig__385FO","colSmall":"styles_colSmall__1_5cx"};